// src/pages/Chapeco/chapecoContent.js

const chapecoContent = {
  'comprar-imovel': {
    title: 'Comprar Imóvel em Chapecó – SC',
    intro: [
      'Encontre casas, apartamentos, terrenos e imóveis comerciais à venda em Chapecó, com informações claras e contato direto com o anunciante.',
      'A UMARKT é um marketplace simples para anunciar e encontrar imóveis. Aqui você visualiza oportunidades reais, aplica filtros objetivos e fala diretamente com proprietários, corretores ou imobiliárias — sem intermediários desnecessários.',
      'Chapecó é um dos polos mais importantes do Sul do Brasil, com economia forte, infraestrutura completa e excelente qualidade de vida. Por isso, a cidade atrai tanto quem busca morar bem quanto quem deseja investir com segurança.'
    ],
    sections: [
      {
        heading: 'Tipos de imóveis à venda em Chapecó',
        paragraphs: ['Na UMARKT você encontra:'],
        list: [
          'Casas à venda em Chapecó',
          'Apartamentos à venda em Chapecó',
          'Terrenos à venda em Chapecó',
          'Salas e imóveis comerciais',
          'Imóveis para investimento',
          'Lançamentos imobiliários'
        ],
        footer: 'Todos os anúncios contam com fotos, descrição e contato direto com o anunciante.'
      },
      {
        heading: 'Por que comprar imóvel em Chapecó?',
        paragraphs: ['Chapecó se destaca por:'],
        list: [
          'Infraestrutura urbana completa',
          'Economia forte e estável',
          'Qualidade de vida elevada',
          'Bons índices de segurança',
          'Educação e saúde bem estruturadas',
          'Expansão urbana planejada',
          'Oportunidades constantes de valorização imobiliária'
        ],
        footer: 'A cidade oferece opções para diferentes perfis — desde regiões centrais até bairros residenciais mais tranquilos.'
      },
      {
        heading: 'Bairros mais procurados de Chapecó',
        list: [
          'Centro',
          'Presidente Médici',
          'Passo dos Fortes',
          'Jardim Itália',
          'Efapi',
          'Bela Vista',
          'Maria Goretti',
          'Engenho Braun',
          'Seminário'
        ],
        footer: 'Cada bairro possui características próprias, como proximidade do comércio, áreas verdes, tranquilidade ou acesso facilitado.'
      },
      {
        heading: 'Como funciona a busca na UMARKT',
        list: [
          'Aplique filtros por tipo de imóvel, preço, tamanho e localização',
          'Veja fotos e detalhes completos dos anúncios',
          'Entre em contato direto com o anunciante',
          'Combine a visita e negocie livremente'
        ],
        footer: 'A UMARKT não interfere na negociação. Nosso papel é conectar quem anuncia a quem procura, de forma simples e transparente.'
      }
    ],
    cta: {
      text: 'Encontre seu próximo imóvel em Chapecó',
      subtitle: 'Explore imóveis à venda, compare opções e fale diretamente com proprietários, corretores e imobiliárias.',
      buttonText: 'Ver imóveis em Chapecó',
      link: '/imoveis?city=Chapecó&transaction_type=venda'
    }
  },

  'casas-a-venda': {
    title: 'Casas à Venda em Chapecó – SC',
    intro: [
      'Se você está buscando casas à venda em Chapecó, a UMARKT reúne opções residenciais em diferentes bairros da cidade, com anúncios diretos de proprietários, corretores e imobiliárias.',
      'A plataforma foi criada para facilitar a busca por casas, oferecendo filtros simples, informações claras e contato direto com o anunciante, sem intermediações desnecessárias.',
      'Chapecó é uma das cidades que mais cresce no Sul do Brasil, com forte economia, bairros organizados e ótima qualidade de vida — fatores que tornam a compra de uma casa uma excelente decisão para morar ou investir.'
    ],
    sections: [
      {
        heading: 'Tipos de casas à venda em Chapecó',
        paragraphs: ['Na UMARKT você encontra diferentes perfis de casas, como:'],
        list: [
          'Casas térreas',
          'Sobrados',
          'Casas geminadas',
          'Casas em condomínio fechado',
          'Casas mobiliadas',
          'Casas de alto padrão',
          'Casas com pátio amplo',
          'Imóveis aptos para financiamento'
        ],
        footer: 'Os anúncios apresentam fotos, descrição e pelo menos um meio de contato direto com o anunciante.'
      },
      {
        heading: 'Bairros mais procurados para comprar casa em Chapecó',
        paragraphs: ['Alguns dos bairros com maior procura por casas incluem:'],
        list: [
          'Centro',
          'Presidente Médici',
          'Bela Vista',
          'Seminário',
          'Engenho Braun',
          'Efapi',
          'Universitário',
          'São Cristóvão'
        ],
        footer: 'Cada bairro possui características próprias, como proximidade de comércio, tranquilidade residencial, acesso rápido ao centro ou valorização imobiliária.'
      },
      {
        heading: 'Por que comprar uma casa em Chapecó?',
        paragraphs: ['Chapecó se destaca por:'],
        list: [
          'Qualidade de vida',
          'Bairros organizados e seguros',
          'Economia forte e diversificada',
          'Boa infraestrutura urbana',
          'Serviços de saúde e educação bem estruturados',
          'Crescimento urbano planejado',
          'Oportunidades de valorização imobiliária'
        ],
        footer: 'A cidade oferece opções tanto para quem busca morar com a família quanto para quem deseja investir em imóveis residenciais.'
      },
      {
        heading: 'Como encontrar casas à venda na UMARKT',
        paragraphs: ['O processo é simples:'],
        list: [
          'Acesse a busca de imóveis',
          'Filtre por tipo: casa, valor e localização',
          'Visualize fotos e informações do imóvel',
          'Entre em contato direto com o anunciante',
          'Combine visita e negociação'
        ],
        footer: 'A UMARKT não interfere na negociação entre as partes.'
      }
    ],
    cta: {
      text: 'Encontre sua casa ideal em Chapecó',
      subtitle: 'Explore as casas à venda em Chapecó, compare opções e fale diretamente com proprietários, corretores e imobiliárias.',
      buttonText: 'Ver casas em Chapecó',
      link: '/imoveis?city=Chapecó&property_type=casa&transaction_type=venda'
    }
  },

  'apartamentos-a-venda': {
    title: 'Apartamentos à Venda em Chapecó – SC',
    intro: [
      'Se você está procurando apartamentos à venda em Chapecó, a UMARKT reúne anúncios de imóveis residenciais em diferentes regiões da cidade, com contato direto com proprietários, corretores e imobiliárias.',
      'A UMARKT é um marketplace simples, criado para facilitar a busca por apartamentos, com filtros objetivos, informações claras e negociação direta, sem burocracia desnecessária.',
      'Chapecó é uma das cidades mais valorizadas do Sul do Brasil, com crescimento constante, boa infraestrutura urbana e forte demanda por apartamentos para moradia e investimento.'
    ],
    sections: [
      {
        heading: 'Tipos de apartamentos à venda em Chapecó',
        paragraphs: ['Na UMARKT você encontra diferentes tipos de apartamentos, como:'],
        list: [
          'Kitnets e studios',
          'Apartamentos de 1, 2 e 3 dormitórios',
          'Apartamentos com suíte',
          'Apartamentos mobiliados',
          'Coberturas',
          'Apartamentos em lançamento',
          'Imóveis de alto padrão',
          'Apartamentos aptos para financiamento'
        ],
        footer: 'Cada anúncio conta com fotos, descrição detalhada e pelo menos um meio de contato direto com o anunciante.'
      },
      {
        heading: 'Bairros mais procurados para comprar apartamento em Chapecó',
        paragraphs: ['Alguns dos bairros com maior procura por apartamentos incluem:'],
        list: [
          'Centro',
          'Passo dos Fortes',
          'Presidente Médici',
          'Jardim Itália',
          'Jardim América',
          'Efapi',
          'Engenho Braun'
        ],
        footer: 'A escolha do bairro varia conforme o perfil do comprador, considerando fatores como proximidade do comércio, universidades, tranquilidade, mobilidade urbana e potencial de valorização.'
      },
      {
        heading: 'Por que comprar apartamento em Chapecó?',
        paragraphs: ['Chapecó é reconhecida por:'],
        list: [
          'Excelente qualidade de vida',
          'Economia forte e diversificada',
          'Infraestrutura urbana completa',
          'Crescimento imobiliário constante',
          'Boa mobilidade',
          'Segurança e organização',
          'Alta demanda por locação e revenda'
        ],
        footer: 'Apartamentos em Chapecó são uma ótima opção tanto para quem busca moradia quanto para quem deseja investir.'
      },
      {
        heading: 'Como encontrar apartamentos à venda na UMARKT',
        paragraphs: ['O processo é simples e direto:'],
        list: [
          'Acesse a busca de imóveis',
          'Filtre por tipo: apartamento, valor e localização',
          'Veja fotos e detalhes do imóvel',
          'Entre em contato direto com o anunciante',
          'Combine visita e negociação'
        ],
        footer: 'A UMARKT não interfere na negociação entre as partes.'
      }
    ],
    cta: {
      text: 'Encontre seu apartamento ideal em Chapecó',
      subtitle: 'Explore apartamentos à venda em Chapecó, compare opções e fale diretamente com proprietários, corretores e imobiliárias.',
      buttonText: 'Ver apartamentos em Chapecó',
      link: '/imoveis?city=Chapecó&property_type=apartamento&transaction_type=venda'
    }
  },

  'terrenos-a-venda': {
    title: 'Terrenos à Venda em Chapecó – SC',
    intro: [
      'Se você está buscando terrenos à venda em Chapecó, a UMARKT reúne anúncios de lotes residenciais, comerciais e áreas para investimento em diferentes regiões da cidade.',
      'A plataforma foi pensada para facilitar o acesso ao mercado imobiliário, permitindo que qualquer pessoa anuncie ou encontre terrenos com informações objetivas, fotos, localização aproximada e contato direto com o anunciante.',
      'Chapecó é uma cidade em constante expansão urbana, o que torna a compra de terrenos uma excelente alternativa para quem deseja construir, investir ou planejar o futuro.'
    ],
    sections: [
      {
        heading: 'Tipos de terrenos à venda em Chapecó',
        paragraphs: ['Na UMARKT você encontra diferentes perfis de terrenos, como:'],
        list: [
          'Terrenos residenciais',
          'Terrenos em loteamentos',
          'Terrenos comerciais',
          'Lotes para construção de casas ou sobrados',
          'Terrenos amplos',
          'Áreas para investimento',
          'Terrenos em regiões de expansão urbana'
        ],
        footer: 'Os anúncios apresentam fotos, descrição e pelo menos um meio de contato direto com o anunciante.'
      },
      {
        heading: 'Bairros com maior oferta de terrenos em Chapecó',
        paragraphs: ['Algumas regiões com maior presença de terrenos à venda incluem:'],
        list: [
          'Efapi',
          'Engenho Braun',
          'Presidente Médici',
          'Bela Vista',
          'Seminário',
          'São Cristóvão'
        ],
        footer: 'Cada região possui características distintas, como novos loteamentos, fácil acesso, potencial de valorização ou perfil mais residencial.'
      },
      {
        heading: 'Por que comprar terreno em Chapecó?',
        paragraphs: ['Chapecó se destaca por:'],
        list: [
          'Crescimento urbano constante',
          'Planejamento urbano organizado',
          'Novos loteamentos estruturados',
          'Economia forte e em expansão',
          'Alto potencial de valorização imobiliária',
          'Oportunidades para construir conforme seu projeto'
        ],
        footer: 'A compra de terrenos em Chapecó atende tanto quem deseja construir para morar quanto investidores que buscam valorização a médio e longo prazo.'
      },
      {
        heading: 'Como encontrar terrenos à venda na UMARKT',
        paragraphs: ['O processo é simples:'],
        list: [
          'Acesse a busca de imóveis',
          'Filtre por tipo: terreno, valor e localização',
          'Veja fotos e informações disponíveis',
          'Entre em contato direto com o anunciante',
          'Combine visita e negociação'
        ],
        footer: 'A UMARKT não interfere na negociação entre as partes.'
      }
    ],
    cta: {
      text: 'Encontre terrenos disponíveis em Chapecó',
      subtitle: 'Compare oportunidades, avalie regiões e fale diretamente com proprietários, corretores e imobiliárias.',
      buttonText: 'Ver terrenos em Chapecó',
      link: '/imoveis?city=Chapecó&property_type=terreno&transaction_type=venda'
    }
  }
}

export default chapecoContent
